import { cva, type VariantProps } from "class-variance-authority";
import { getAlertIconName } from "../alert/get-alert-icon-name";
import { Spinner } from "../spinner";
import { icon } from "./icons";

export function AlertIcon({
	variant = "danger",
	spacing = "compact",
	isLoading,
}: VariantProps<typeof alertIcon> & {
	spacing?: "compact" | "normal";
	isLoading?: boolean;
}) {
	const iconClasses = alertIcon({ variant, spacing });
	const Icon = isLoading ? Spinner : icon(getAlertIconName(variant || "neutral"));

	return (
		<Icon
			className={iconClasses}
			size={15}
		/>
	);
}

const alertIcon = cva(["text-2xl"], {
	variants: {
		variant: {
			success: ["stroke-emerald-500"],
			danger: ["stroke-red-500"],
			warning: ["stroke-amber-500"],
			info: ["stroke-blue-500"],
			neutral: ["stroke-neutral-500"],
		},
		spacing: {
			compact: ["text-lg"],
			normal: ["text-2xl"],
		},
	},
	defaultVariants: {
		variant: "neutral",
	},
});
